document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("btn-whatsapp");
  if (!btn) return;

  btn.addEventListener("click", function () {

    const nombre = document.querySelector('[name="nombre"]').value;
    const apellido = document.querySelector('[name="apellido"]').value;
    const telefono = document.querySelector('[name="telefono"]').value;
    const direccion = document.querySelector('[name="direccion"]').value;
    const ciudad = document.querySelector('[name="ciudad"]').value;
    const departamento = document.querySelector('[name="departamento"]').value;
    const producto = document.querySelector('[name="producto"]').value;
    const precio = document.querySelector('[name="precio"]').value;

    if (!nombre || !apellido || !telefono || !direccion || !ciudad || !departamento) {
      alert("Por favor completa todos los campos");
      return;
    }

    const mensaje = `Hola 👋
Quiero confirmar mi pedido *Pago Contra Entrega*

📦 Producto: ${producto}
💰 Precio: $${precio}
👤 Nombre: ${nombre} ${apellido}
📞 Teléfono: ${telefono}
📍 Dirección: ${direccion}
🏙️ Ciudad: ${ciudad}
🗺️ Departamento: ${departamento}

👉 Responde:
✅ CONFIRMAR PEDIDO
❌ CANCELAR`;

    const telefonoTienda = "573013190814";
    const url = `https://wa.me/${telefonoTienda}?text=${encodeURIComponent(mensaje)}`;

    window.open(url, "_blank");

  });

});



